import { lazy } from "react"

const SlackCallbackPage$$__react__lazy__component = lazy(() => 
    import("./SlackCallbackPage__original__module.mjs")
        .then(module => module.get_$$SlackCallbackPage$$SlackCallbackPage$$react__component$$3dys71hwi4vq4())
        .then(component => ({ default: component }))
)

export const get_$$SlackCallbackPage$$SlackCallbackPage$$react__component$$3dys71hwi4vq4 = () => SlackCallbackPage$$__react__lazy__component